// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PdfLayout .PdfLayout-Content:has(.InvoicePdf) {
  --pdf-width: 11in;
  --pdf-spacing: 0.39in;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf {
  position: relative;
  font-family: "Gotham", sans-serif;
  display: flex;
  flex-direction: column;
  width: var(--pdf-width);
  padding: 0;
  min-height: 100%;
  min-height: 100vh;
  height: auto;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .SkyhopPdfHeader:before, .PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .SkyhopPdfHeader:after {
  content: "";
  display: block;
  width: 1in;
  height: 0.5rem;
  position: absolute;
  bottom: -0.5rem;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .SkyhopPdfHeader:before {
  background-color: var(--bs-secondary);
  left: 0;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .SkyhopPdfHeader:after {
  background-color: #40ade2;
  right: 0;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .InvoicePdf-Content {
  padding: calc(var(--pdf-spacing) / 2) var(--pdf-spacing) calc(var(--pdf-spacing) / 2) var(--pdf-spacing);
  flex-grow: 1;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .InvoicePdf-Content .InvoicePdf-Details {
  display: flex;
  flex-direction: row;
  margin-bottom: calc(var(--pdf-spacing) / 2);
  gap: 1rem;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .InvoicePdf-Content .InvoicePdf-Details > ul {
  width: 25%;
  margin: 0;
  padding: 0;
  list-style: none;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .InvoicePdf-Content .InvoicePdf-Details > ul li {
  font-weight: 400;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .InvoicePdf-Content .InvoicePdf-Details > ul li strong {
  font-weight: 700;
}
.PdfLayout .PdfLayout-Content:has(.InvoicePdf) .InvoicePdf .InvoicePdf-Content .InvoicePdf-Details > ul li.InvoicePdf-Note {
  color: #ff0000;
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/layouts/Invoice/styles.scss"],"names":[],"mappings":"AACE;EACE,iBAAA;EACA,qBAAA;AAAJ;AACI;EACE,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AACN;AACQ;EAEE,WAAA;EACA,cAAA;EACA,UAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAAV;AAEQ;EACE,qCAAA;EACA,OAAA;AAAV;AAEQ;EACE,yBAAA;EACA,QAAA;AAAV;AAGM;EACE,wGAAA;EACA,YAAA;AADR;AAEQ;EACE,aAAA;EACA,mBAAA;EACA,2CAAA;EACA,SAAA;AAAV;AACU;EACE,UAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACZ;AAAY;EACE,gBAAA;AAEd;AADc;EACE,gBAAA;AAGhB;AADc;EACE,cAAA;AAGhB","sourcesContent":[".PdfLayout {\n  .PdfLayout-Content:has(.InvoicePdf) {\n    --pdf-width: 11in;\n    --pdf-spacing: 0.39in;\n    .InvoicePdf {\n      position: relative;\n      font-family: 'Gotham', sans-serif;\n      display: flex;\n      flex-direction: column;\n      width: var(--pdf-width);\n      padding: 0;\n      min-height: 100%;\n      min-height: 100vh;\n      height: auto;\n      .SkyhopPdfHeader {\n        &:before,\n        &:after {\n          content: '';\n          display: block;\n          width: 1in;\n          height: 0.5rem;\n          position: absolute;\n          bottom: -0.5rem;\n        }\n        &:before {\n          background-color: var(--bs-secondary);\n          left: 0;\n        }\n        &:after {\n          background-color: #40ade2;\n          right: 0;\n        }\n      }\n      .InvoicePdf-Content {\n        padding: calc(var(--pdf-spacing) / 2) var(--pdf-spacing) calc(var(--pdf-spacing) / 2) var(--pdf-spacing);\n        flex-grow: 1;\n        .InvoicePdf-Details {\n          display: flex;\n          flex-direction: row;\n          margin-bottom: calc(var(--pdf-spacing) / 2);\n          gap: 1rem;\n          > ul {\n            width: 25%;\n            margin: 0;\n            padding: 0;\n            list-style: none;\n            li {\n              font-weight: 400;\n              strong {\n                font-weight: 700;\n              }\n              &.InvoicePdf-Note {\n                color: #ff0000;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
